// Initialize Cloud Firestore through Firebase
import { initializeApp } from "firebase/app";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
import { firebaseConfig } from "./config";
// import { getFirestore } from "firebase/firestore";

// Uses the full config from config.js rather than a partial inline copy
// (that partial copy was missing appId - harmless for Auth/Firestore, which
// never needed it, but App Check's token exchange hits
// /projects/{projectId}/apps/{appId}:exchange... and fails with
// "Invalid App ID: undefined" without it).
const app = initializeApp(firebaseConfig);

// App Check, matching dashboard-admin-v2/src/lib/firebase.ts. Both dashboards are
// registered as the SAME Firebase web app (appId
// 1:711915071503:web:fd350eb83ade180a6c9b7a), so they share one App Check
// registration and one reCAPTCHA Enterprise key - which means this key's
// domain list has to carry BOTH dashboards' domains, not just one.
//
// This was attempted here once before and reverted (commit cbae85d9,
// 2026-09-07): on firebase 9.23.0 it failed with a content-free
// "appCheck/recaptcha-error" (firebase-js-sdk issues #7969, #6708), so the
// experiment was scoped to the lower-traffic admin tool instead. SDK 12.19.0
// fixes it - verified from a cold state, IndexedDB cleared and signed out,
// where the reCAPTCHA mint and the token exchange both returned 200 and a real
// X-Firebase-Appcheck header reached Identity Toolkit.
//
// Monitoring-only. Identity Toolkit must stay on Monitor in the App Check
// console until the verified share approaches 100% - it was 3% while only the
// admin app sent tokens, so enforcing before this ships and settles would
// reject essentially every customer login.
initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider(
    "6LfLYa4tAAAAAIHT1j5I13toGZ5JEWTGsA0MKVAR",
  ),
  isTokenAutoRefreshEnabled: true,
});

// const db = getFirestore();

export {};
